export default "__VITE_ASSET__93460237__"